import script from "./UpdateApprovalAuthorityPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateApprovalAuthorityPage.vue?vue&type=script&setup=true&lang=js"

import "./UpdateApprovalAuthorityPage.vue?vue&type=style&index=0&id=d7ffc8b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7ffc8b8"]])

export default __exports__